<template>
  <div class="wallet-on-site-container">
    <Wallet
      class="wallet-on-site"
      :style="`${is_settings_selection ? 'filter: blur(4px);' : ''}`"
      :mobile_wallet_show_settings="isMobileWalletShowSettings"
      @touchstart.native="walletSwipeStart"
      @touchend.native="walletSwipeEnd"
    >
      <!-- @touchmove.native="walletSwipeMove" -->
      <template #left>
        <transition
        :name="`wallet-slide-${$route.params.direction}`"
        >
          <router-view :key="$route.params.takt_index" name="left"/>
        </transition>
      </template>
      <template #center>
        <transition
        :name="`wallet-slide-${$route.params.direction}`"
        >
          <router-view :key="$route.params.takt_index" name="center"/>
        </transition>
      </template>
      <template #right>
        <transition
        :name="`wallet-slide-${$route.params.direction}`"
        >
          <router-view :key="$route.params.takt_index" name="right"/>
        </transition>
      </template>
    </Wallet>
    <TransitionFade>
      <div
        v-if="is_settings_selection"
        class="wallet-settings-overlay"
        :style="`padding: ${overlay_padding};`"
        @click="overlayClicked()"
      >
        <!-- ACTUAL SETTINGS -->
        <div class="wallet-settings-overlay-items">
          <!-- SORT BY -->
          <!-- TRAIN -->
          <WalletSettingList
            :value="{ trains: getWalletSettings.trains.length === 0
              ? [getStatisticsTrainSelector(project_id)[0].value]
              : getWalletSettings.trains }"
            :options="{ trains: getStatisticsTrainSelector(project_id) }"
            :selected="getWalletSettings.sorting === 'trains'"
            multiselect
            badge
            icon="takt-plan-train"
            :size="settings_item_width"
            identifier="trains"
            :show_children="show_children === 'trains'"
            @showChildren="setShowChildren($event)"
            @selectOption="setWalletSettings({ setting: $event.setting, value: $event.value })"
          />
          <!-- STATUS -->
          <WalletSettingList
            :value="{ status: getWalletSettings.status.length === 0
              ? [getFullStatusArray[0].value]
              : getWalletSettings.status }"
            :options="{ status: getFullStatusArray }"
            :selected="getWalletSettings.sorting === 'status'"
            multiselect
            :size="settings_item_width"
            identifier="status"
            :show_children="show_children === 'status'"
            @showChildren="setShowChildren($event)"
            @selectOption="setWalletSettings({ setting: $event.setting, value: $event.value })"
          />
          <!-- COLOR -->
          <WalletSettingList
            :value="{ colors: getWalletSettings.colors.length === 0
              ? [getTWorkpackageColors[0].value]
              : getWalletSettings.colors }"
            :options="{ colors: getTWorkpackageColors }"
            :selected="getWalletSettings.sorting === 'colors'"
            multiselect
            :size="settings_item_width"
            identifier="colors"
            :show_children="show_children === 'colors'"
            @showChildren="setShowChildren($event)"
            @selectOption="setWalletSettings({setting: $event.setting, value: $event.value})"
          />
          <!-- ICON -->
          <WalletSettingList
            :value="{ icons: getWalletSettings.icons.length === 0
              ? [getTWorkpackageIcons[0].value]
              : getWalletSettings.icons }"
            :options="{ icons: getTWorkpackageIcons }"
            :selected="getWalletSettings.sorting === 'icons'"
            multiselect
            :size="settings_item_width"
            identifier="icons"
            :show_children="show_children === 'icons'"
            @showChildren="setShowChildren($event)"
            @selectOption="setWalletSettings({ setting: $event.setting, value: $event.value })"
          />
          <!-- RESET SETTINGS -->
          <WalletSettingList
            action
            icon="restart"
            :size="settings_item_width"
            @actionClicked="resetWalletSettings({
                setting: 'trains',
                value: getStatisticsTrainSelector(project_id)[0].value
              })"
          />

          <div class="wallet-settings-line" />

          <!-- FILTER -->
          <!-- CHOOSE FILTER -->
          <WalletSettingList
            :value="{ steps: getWalletSettings.steps }"
            :options="{ steps: isWalletShowWorkpackages
              ? [
                  {icon: $store.state.Ultra.step_icons['quality'], ticon: $store.state.Ultra.step_icons['quality'], value: $t('Project.Wallet.Filter[1]'), tooltip: 'Quality'},
                  {icon: $store.state.Ultra.step_icons['defect'], ticon: $store.state.Ultra.step_icons['defect'], value: $t('Project.Wallet.Filter[2]'), tooltip: 'Defect'},
                  {icon: $store.state.Ultra.step_icons['handover'], ticon: $store.state.Ultra.step_icons['handover'], value: $t('Project.Wallet.Filter[3]'), tooltip: 'Handover'},
                  {icon: $store.state.Ultra.step_icons['logistic'], ticon: $store.state.Ultra.step_icons['logistic'], value: $t('Project.Wallet.Filter[4]'), tooltip: 'Logistic'},
                  {icon: $store.state.Ultra.step_icons['design'], ticon: $store.state.Ultra.step_icons['design'], value: $t('Project.Wallet.Filter[5]'), tooltip: 'Design'},
                ]
              : [
                  {icon: $store.state.Ultra.step_icons['work'], ticon: $store.state.Ultra.step_icons['work'], value: $t('Project.Wallet.Filter[0]'),  tooltip: 'Work'},
                  {icon: $store.state.Ultra.step_icons['quality'], ticon: $store.state.Ultra.step_icons['quality'], value: $t('Project.Wallet.Filter[1]'), tooltip: 'Quality'},
                  {icon: $store.state.Ultra.step_icons['defect'], ticon: $store.state.Ultra.step_icons['defect'], value: $t('Project.Wallet.Filter[2]'), tooltip: 'Defect'},
                  {icon: $store.state.Ultra.step_icons['handover'], ticon: $store.state.Ultra.step_icons['handover'], value: $t('Project.Wallet.Filter[3]'), tooltip: 'Handover'},
                  {icon: $store.state.Ultra.step_icons['logistic'], ticon: $store.state.Ultra.step_icons['logistic'], value: $t('Project.Wallet.Filter[4]'), tooltip: 'Logistic'},
                  {icon: $store.state.Ultra.step_icons['design'], ticon: $store.state.Ultra.step_icons['design'], value: $t('Project.Wallet.Filter[5]'), tooltip: 'Design'},
                  /* {icon: $store.state.Ultra.step_icons['material'], ticon: $store.state.Ultra.step_icons['material'], value: $t('Project.Wallet.Filter[6]'), tooltip: 'Material'}, */
                  /* {icon: $store.state.Ultra.step_icons['machine'], ticon: $store.state.Ultra.step_icons['machine'], value: $t('Project.Wallet.Filter[7]'), tooltip: 'Machine'}, */
                ] }"
            :selected="getWalletSettings.filter"
            :button_color_selected="'grey darken-1'"
            multiselect
            icon="filter"
            :size="settings_item_width"
            identifier="steps"
            :show_children="show_children === 'steps'"
            @button-clicked="setWalletSettings({setting: 'filter', value: !getWalletSettings.filter})"
            @showChildren="setShowChildren($event)"
            @selectOption="setWalletSettings({setting: $event.setting, value: $event.value}),
                            setWalletSettings({setting: 'filter', value: true})"
          />
          <!-- RESET FILTER -->
          <WalletSettingList
            action
            icon="restart"
            :size="settings_item_width"
            @actionClicked="resetWalletStepFilter()"
          />

          <div class="wallet-settings-line" />

          <!-- SHOW/HIDE WORKPACKAGE -->
          <WalletSettingList
            action
            icon="takt-plan-workpackage"
            :size="settings_item_width"
            @actionClicked="setWalletShowWorkpackages(!isWalletShowWorkpackages)"
          />

          <div class="wallet-settings-line" />
          
          <WalletSettingList
            action
            :icon="$store.state.View.on_site?'screen':'smartphone'"
            :size="settings_item_width"
            @actionClicked="changeValue('on_site', 'On_Site')"
          />
        </div>

        <!-- CALENDER NAVIGATION -->
        <div
          class="wallet-settings-calender-navigation"
          :style="`
            margin-top: ${settings_spacing}px;
            margin-bottom: ${settings_spacing}px;
            margin-right: ${settings_width - settings_spacing / 2 + settings_spacing}px;
            height: ${settings_width}px;
          `"
        >
        <!-- margin: ${settings_spacing}px ${settings_width - settings_spacing / 2 + settings_spacing}px; -->
        <!-- to do refacture -->
        <v-btn
          v-if="$route.matched[1] &&
            ($route.matched[1].name === 'ProjectTaktPlan' ||
            $route.matched[1].name === 'ProjectWallet') &&
            (
              getOwnTWorkPackages($route.params.project_id) &&
              getOwnTWorkPackages($route.params.project_id).length !== 0
            )
            "
          @click="setShowOwnWps(!isShowOwnWps)"
          :color="isShowOwnWps?'grey darken-1':''"
          >
          MY WPS
        </v-btn>
          <div
            id="wallet-settings-calender-navigation-inner"
            :style="`margin-left: ${inner_center ? settings_width - settings_spacing / 2 + settings_spacing : 0}px;`"
          >
            <!-- NAVIGATE LEFT -->
            <button
              class="wallet-settings-calender-navigation-button"
              :style="`
                width: ${settings_nav_width}px;
                height: ${settings_nav_width}px;
              `"
              v-ripple
              @click.prevent.stop="$router.push({
                name: 'ProjectWalletTakt',
                params: {
                  takt_index: parseInt($route.params.takt_index) - parseInt(1),
                  direction: 'left'
                }
              })"
            >
              <TIcon name="chevron-left" large />
            </button>

            <!-- CALENDER ACTION -->
            <button
              class="wallet-settings-calender-navigation-button"
              :style="`
                width: ${settings_nav_width}px;
                height: ${settings_nav_width}px;
              `"
              v-ripple
              @click.prevent.stop="$router.push({
                name: 'ProjectWalletTakt',
                params: {
                  takt_index: getCurrentTaktIndex($route.params.project_id) !== false?
                              Math.abs(getCurrentTaktIndex($route.params.project_id)):1,
                  direction: 'none',
                }
              })"
            >
              <TIcon name="calendar" large />
            </button>
            <!-- NAVIGATE RIGHT -->
            <button
              class="wallet-settings-calender-navigation-button"
              :style="`
                width: ${settings_nav_width}px;
                height: ${settings_nav_width}px;
              `"
              v-ripple
              @click.prevent.stop="$router.push({
                name: 'ProjectWalletTakt',
                params: {
                  takt_index: parseInt($route.params.takt_index) + parseInt(1),
                  direction: 'right',
                }
              })"
            >
              <TIcon name="chevron-right" large />
            </button>
          </div>
        </div>
      </div>
    </TransitionFade>
    <button
      class="wallet-floating-action-button grey darken-4"
      :style="`
        width: ${settings_width}px;
        height: ${settings_width}px;
        bottom: ${settings_spacing}px;
        right: ${settings_spacing}px;
      `"
      @click.stop.prevent="is_settings_selection = !is_settings_selection"
    >
      <TIcon name="gear-small" color="white" large />
    </button>
  </div>
</template>
<script>
  import store from '@/store/index';
  import TIcon from '@/components/Taktify/TIcon.component.vue';
  import TransitionFade from '@/components/WorkPackageWIP/TransitionFade.component.vue';
  import WalletSettingList from '@/components/ProjectWallet/WalletSettingList.component.vue';
  import { WalletMixin } from '@/mixins/Wallet.mixin.js';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    props: [
      'project_id',
    ],

    components: {
      TIcon,
      TransitionFade,
      WalletSettingList,
    },

    mixins: [
      WalletMixin,
    ],

    data: () => ({
      is_settings_selection: false,
      settings_spacing: 24,
      settings_width: 64,
      settings_item_width: 40,
      settings_nav_width: 54,
      show_children: '',
      inner_center: false,
    }),

    created(){
      // let takt_index = this.getCurrentTaktIndex(this.project_id) !== false ? Math.abs(this.getCurrentTaktIndex(this.project_id)) : 1;
      let takt_index;
      if(this.getCurrentTaktIndex(this.project_id) !== false) {
        takt_index = Math.abs(this.getCurrentTaktIndex(this.project_id));
      }
      else {
        takt_index = 1;
      }

      if (this.$route.params.calculate_takt_time && takt_index !== 1) {
        this.$router.push({
          name: 'ProjectWalletTakt',
          params: {
            takt_index: takt_index,
            calculate_takt_time: false,
            direction: 'all'
          }
        });
      }
    },

    computed: {
      ...mapGetters('ProjectCalendar', [
        'getCurrentTaktIndex'
      ]),
      ...mapGetters('Project', [
      'getOwnTWorkPackages',
      ]),
      ...mapGetters('View', [
        'isShowOwnWps',
      ]),

      overlay_padding() {
        let ret = "";

        ret += "0" + " "; // top
        ret += this.settings_spacing + this.settings_width / 2 - this.settings_item_width / 2 + "px" + " "; //right
        ret += "0" + " "; // bottom
        // ret += this.settings_width + 2 * this.settings_spacing + "px" + " "; // bottom
        ret += this.settings_spacing + this.settings_width / 2 - this.settings_item_width / 2 + "px"; // left
        return ret;
      },
    },

    methods: {
       ...mapActions('View', [
       'setShowOwnWps',
       'setValue',
      ]),

      changeValue(variable, desc) {
          localStorage.setItem(desc.replaceAll(' ', '_'), !this.$store.state.View[variable]);
          this.setValue({key: variable, value: !this.$store.state.View[variable]});
      },
      
      setShowChildren(identifier) {
        if(identifier === this.show_children)
          this.show_children = '';
        else
          this.show_children = identifier;
      },

      overlayClicked() {
        if(this.show_children)
          this.show_children = '';
        else
          this.is_settings_selection = false;
      }
    },

    // NOTE: this should probably be a watcher
    updated() {
      if(document.getElementById('wallet-settings-calender-navigation-inner')) {
        this.inner_center = document.getElementById('wallet-settings-calender-navigation-inner').scrollWidth >= 300;
      }
    },

    beforeRouteEnter(to, from, next) {
      store.dispatch('ProjectWallet/resetWalletSettings', {
          setting: 'trains',
          value: store.getters['Project/getProject'](to.params.project_id).trains[0],
        })
        .then(() => {
          store.dispatch('ProjectWallet/requestProjectStepCards', {
              project_id: to.params.project_id,
              takt_index: to.params.takt_index-1,
            })
            .then(() => {
              store.dispatch('ProjectWallet/requestProjectStepCards', {
                project_id: to.params.project_id,
                takt_index: to.params.takt_index,
              })
              .then(() => {
                store.dispatch('ProjectWallet/requestProjectStepCards', {
                  project_id: to.params.project_id,
                  takt_index: parseInt(to.params.takt_index) + parseInt(1),
                })
                .then(() => {
                  next();
                });
              });
            });
        });
    },

    beforeRouteUpdate(to, from, next) {
      if (from.params.takt_index !== to.params.takt_index) {
        if (to.params.direction === 'all') {
          store.dispatch('ProjectWallet/requestProjectStepCards', {
              project_id: to.params.project_id,
              takt_index: to.params.takt_index-1,
            })
            .then(() => {
              store.dispatch('ProjectWallet/requestProjectStepCards', {
                project_id: to.params.project_id,
                takt_index: to.params.takt_index,
              })
              .then(() => {
                store.dispatch('ProjectWallet/requestProjectStepCards', {
                  project_id: to.params.project_id,
                  takt_index: parseInt(to.params.takt_index) + parseInt(1),
                })
                .then(() => {
                  next();
                });
              });
            });
        } else {
          let takt_index = to.params.takt_index + 1
          if (to.params.direction === 'left') {
            takt_index = to.params.takt_index - 1
          }
          store.dispatch('ProjectWallet/requestProjectStepCards', {
            project_id: to.params.project_id,
            takt_index: takt_index,
          })
          .then(() => {
            next();
          });
        }
      } else {
        next();
      }
    },
  }
</script>
<style>
.wallet-on-site-container {
  position: relative;
  color: white;
  fill: white;
}
.wallet-on-site {
  height: 100%;
  transition: filter 0.2s ease-in-out;
}
.wallet-settings-overlay {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: calc(100% - 48px); /* height without header */
  background-color: #000d;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.wallet-settings-overlay-items {
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
  grid-gap: 4px;
}
.wallet-settings-calender-navigation {
  display: flex;
  align-items: center;
  justify-content: center;
}
#wallet-settings-calender-navigation-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: min(100%, 300px);
}
.wallet-settings-calender-navigation-button {
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.wallet-settings-button, .wallet-settings-button-option {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}
.wallet-settings-button-option {
  border: 1px solid white;
}
.wallet-settings-line {
  width: 40px;
  border-bottom: 1px solid #FFF6;
}
.wallet-floating-action-button {
  position: fixed;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 8px #0008;
}
</style>
